
export enum ResearchGroupType {
  Single = 0,
  With360 = 1
}
